import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  INFO_AND_SUPPORT_INITIALIZATION,
  ON_CHANGE_FEEDBACK_FORM,
  RESET_FEEDBACK_PAGE,
  ON_SUBMIT_FEEDBACK,
  SAVE_FEEDBACK_DRAFT,
  GET_TRANSACTIONS_LIST,
  IS_UNSAVED,
  CLEAR_DIRTY_DRAFT,
} from "../actions/constant";
import i18n from "../i18n";
const initialState = {
  amountReseter: false,
  feedbackForm: { topic: "", body: "" },
  counterState: 0,
  isLoading: false,
  draft: false,
  draftData: {},
  creditAmount: 0,
  draftBtn: false,
  submit: false,
  darftSaved: false,
  hasDraft: false,
  submitTopic: null,
  isDirty: false,
  theDraft: {}
};
function reducer(state = initialState, action) {
  const theDraft = JSON.parse(localStorage.getItem("theSupportDraft")) || {};
  state.theDraft = theDraft
  const checkHasDraft = () => {
    let vAlertMessages = {
      title: i18n.t("support.SAVED_DRAFT_DATA_TITLE"),
      text: i18n.t("support.SAVED_DRAFT_DATA_TEXT"),
    };

    const hasDraft = !Object.values(theDraft).every(
      (x) => x === null || x === ""
    );
    state.hasDraft = hasDraft;
  };

  function unsavedDataChecker(type) {

    let vAlertMessages = {
      title: i18n.t("support.SAVED_DRAFT_DATA_TITLE"),
      text: i18n.t("support.SAVED_DRAFT_DATA_TEXT"),
      screen: "account",
    };
    if (type === "yes") {
      IS_UNSAVED("yes");
      localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
    } else {
      IS_UNSAVED("no");
      localStorage.removeItem("unsavedAlertData");
    }
  }

  switch (action.type) {
    case getStarted(INFO_AND_SUPPORT_INITIALIZATION):
      checkHasDraft();
      return {
        ...state,
        isLoading: true,
      };
    case getSucceeded(INFO_AND_SUPPORT_INITIALIZATION):
      state.creditAmount = action.payload.creditAmount;
      let getDraft = JSON.parse(localStorage.getItem("supportDraft"));
      if (getDraft && getDraft != "null") {
        state.draftData = {
          topic: getDraft.topic,
          draft: getDraft.body,
        };
        state.feedbackForm = {
          topic: getDraft.topic,
          body: getDraft.body,
        };
        state.draft = true;
      } else {
        state.feedbackForm = {};
        state.draftData = {};
        state.draft = false;
      }
      return {
        ...state,
      };
    case getEnded(INFO_AND_SUPPORT_INITIALIZATION):
      return {
        ...state,
        isLoading: false,
      };
    case getStarted(ON_SUBMIT_FEEDBACK):
      state.submitTopic = state.feedbackForm.topic;
      return {
        ...state,
        isLoading: true,
        submit: false,
        isDirty: false,
      };

    case getSucceeded(ON_SUBMIT_FEEDBACK):
      unsavedDataChecker("no");
      localStorage.removeItem("supportDraft");
      localStorage.removeItem("unsavedAlertData");
      delete theDraft[state.feedbackForm.topic];
      localStorage.setItem("theSupportDraft", JSON.stringify(theDraft));
      return {
        ...state,
        draft: false,
        submit: true,
        isDirty: false,
      };
    case getEnded(ON_SUBMIT_FEEDBACK):
      delete theDraft[state.submitTopic];
      localStorage.setItem("theSupportDraft", JSON.stringify(theDraft));
      state.submitTopic = null;
      return {
        ...state,
        isLoading: false,
      };

    case ON_CHANGE_FEEDBACK_FORM:
      state.feedbackForm[action.name] = action.value;
      let dirty = state.isDirty;
      let prevBody = action.prevBody;
      if (action.name === "topic") {
        /// on change select, selected topic is action.value
        unsavedDataChecker("no");
        state.feedbackForm.body = theDraft[action.value]
          ? theDraft[action.value]
          : "";
      }
      if (action.name === "body") {
        /// on change form, active topic is action.value
        theDraft[state.feedbackForm.topic] = action.value;
        // dirty = true;
        if (action.value === "") {
          unsavedDataChecker("no");
          dirty = false;
        } else {
          if (action.value.length > 0 && action.value !== prevBody) {
            unsavedDataChecker("yes");
            dirty = true;
          } else {
            unsavedDataChecker("no");
            dirty = false;
          }
        }
      }
      localStorage.setItem("theSupportDraft", JSON.stringify(theDraft));
      checkHasDraft();

      return {
        ...state,
        counterState: state.counterState + 1,
        isDirty: dirty,
      };

    case RESET_FEEDBACK_PAGE:
      if (action.clear) {
        delete theDraft[state.feedbackForm.topic];
        unsavedDataChecker("no");
        localStorage.setItem("theSupportDraft", JSON.stringify(theDraft));
      }

      state.feedbackForm = {
        topic: "null",
        body: "",
      };
      return {
        ...state,
        darftSaved: false,
        isDirty: false,
      };

    case SAVE_FEEDBACK_DRAFT:
      let savedDraft = {
        topic: state.feedbackForm.topic,
        body: state.feedbackForm.body,
      };

      localStorage.setItem("supportDraft", JSON.stringify(savedDraft));
      return {
        ...state,
        darftSaved: true,
        counterState: state.counterState + 1,
        isDirty: false,
      };
    case CLEAR_DIRTY_DRAFT:
      return {
        ...state,
        isDirty: false,
      };

    case getStarted(GET_TRANSACTIONS_LIST):
      return { ...state, isLoading: true };
    case getSucceeded(GET_TRANSACTIONS_LIST):
      state.transActions = action.payload;
      state.feedbackForm.topic = "";
      return { ...state };
    case getEnded(GET_TRANSACTIONS_LIST):
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/infoAndSupportReducer.js